import {RouteRecordRaw} from "vue-router";
import store from "@/store";
import {FuneralPlanTab} from "@/shared/domain/enum/funeral-plan-tab.model";
import RouteSettings from "@/router/route.settings";
import {useFavicon, useTitle} from "@vueuse/core";
import {ref} from "vue";

const MagSegurosRoute: RouteRecordRaw = {
  path: 'mag-seguros',
  name: 'MAG Seguros',
  component: () => import("@/components/BasicRouter.vue"),
  beforeEnter: (to, from, next) => {
    store.commit('resetValues');
    store.commit('setMagSeguros', true);
    store.commit('changeStyleMode', 'mag-seguros')
    useFavicon(ref('mag-seguros.ico'), {baseUrl: '/'});
    useTitle("MAG - Legacy");
    document.querySelector('body')!.className = '';
    document.querySelector('body')?.classList.add("mag-seguros");
    store.commit('changeFuneralPlanTab', FuneralPlanTab.LOST_SOMEONE);
    //store.commit("changeShowFullLoad", true);
    next();
  },
  children: [
    {
      name: 'MAG Seguros ',
      path: '',
      beforeEnter: (to, from, next) => {
        store.commit('changeInitPurchaseUrl', to.fullPath);
        RouteSettings.checkRouteDependecies(to.path, next, 0);
      },
      meta: {
        spacingTop: true,
        solidBackground: true
      },
      component: () => import("@/views/mag-seguros/mag-seguros-page/mag-seguros-page.vue")
    },
  ],
};

export default MagSegurosRoute;

const oldRoutes: RouteRecordRaw[] = [
  {
    name: 'MAG Seguros',
    path: '',
    beforeEnter: (to, from, next) => {
      store.commit('changeInitPurchaseUrl', to.fullPath);
      RouteSettings.checkRouteDependecies(to.path, next, 0);
    },
    meta: {
      spacingTop: true,
      solidBackground: true
    },
    component: () => import("@/views/plans/supplier/FuneralPlanSupplierPage.vue")
  },
  {
    name: 'Dados Ente-Falecido',
    path: 'dados',
    beforeEnter: (to, from, next) => {
      RouteSettings.checkRouteDependecies(to.path, next, 1);
    },
    meta: {
      spacingTop: true,
    },
    component: () => import("@/views/mag-seguros/old/deceased-data/DeceasedDataPage.vue")
  },
  {
    name: 'Dados Cliente',
    path: 'dados-cliente',
    beforeEnter: (to, from, next) => {
      RouteSettings.checkRouteDependecies(to.path, next, 1);
      //next();
    },
    meta: {
      spacingTop: true,
    },
    component: () => import("@/views/mag-seguros/old/client-data/ClientDataPage.vue")
  }
]
